module.exports = __webpack_public_path__ + "img/195.ff0c9b98.jpg";